export const getAllUsersData = ({ allUsers }) => {
  return allUsers;
};

export const getAllBrokersData = ({ allUsers }) => {
  return allUsers.filter(user => user.role === 'broker');
};

export const getUserByID =
  id =>
  ({ allUsers }) => {
    return allUsers.find(user => user && user._id === id);
  };
